
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.0918 16.9083L15.0002 13.8416C16.2002 12.3453 16.7814 10.446 16.6242 8.53434C16.4669 6.62267 15.5832 4.84391 14.1548 3.56379C12.7263 2.28368 10.8617 1.59951 8.94427 1.65198C7.02686 1.70445 5.20243 2.48956 3.84612 3.84587C2.4898 5.20219 1.70469 7.02662 1.65222 8.94402C1.59976 10.8614 2.28392 12.7261 3.56403 14.1545C4.84415 15.583 6.62292 16.4667 8.53458 16.6239C10.4462 16.7812 12.3455 16.2 13.8418 14.9999L16.9085 18.0666C16.986 18.1447 17.0781 18.2067 17.1797 18.249C17.2812 18.2913 17.3902 18.3131 17.5002 18.3131C17.6102 18.3131 17.7191 18.2913 17.8206 18.249C17.9222 18.2067 18.0144 18.1447 18.0918 18.0666C18.242 17.9112 18.326 17.7035 18.326 17.4874C18.326 17.2713 18.242 17.0636 18.0918 16.9083ZM9.16683 14.9999C8.01311 14.9999 6.88529 14.6578 5.926 14.0168C4.96672 13.3759 4.21904 12.4648 3.77753 11.3989C3.33602 10.333 3.2205 9.16012 3.44558 8.02856C3.67066 6.89701 4.22624 5.8576 5.04204 5.0418C5.85785 4.22599 6.89725 3.67042 8.0288 3.44534C9.16036 3.22026 10.3332 3.33578 11.3992 3.77729C12.4651 4.2188 13.3761 4.96647 14.0171 5.92576C14.658 6.88505 15.0002 8.01286 15.0002 9.16659C15.0002 10.7137 14.3856 12.1974 13.2916 13.2914C12.1977 14.3853 10.7139 14.9999 9.16683 14.9999Z","fill":"currentColor"}})])
          )
        }
      }
    